import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "h1" }

import { reactive, ref, computed, onMounted } from "vue";
import ContentSlider from "./../objects/ContentSlider.vue";
import { SwiperSlide } from "swiper/vue";
import CatalogProduct from "@/vue/components/product/CatalogProduct.vue";
import InlineProduct from "@/vue/components/product/InlineProduct.vue";
import { getRecommendation } from "@/vue/api/product/getRecommendations.ts";
import { logClick } from "@/vue/api/clerk/log.ts";
import { ProductObjectViewModel } from "../../@types/generated/ProductObjectViewModel";

type Props = {
	inline?: Boolean;
	type: string;
	heading: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Recommended',
  props: {
    inline: {},
    type: {},
    heading: {}
  },
  setup(__props: any) {

const props = __props;
const isLoading = ref(true);
const slider = ref({
	heading: props.heading,
	id: "",
	slides: [1, 1, 1, 1],
	show: true,
});

const breakpoints = computed(() => {
	if (props.inline) {
		return {
			0: {
				slidesPerView: 1,
				slidesPerColumn: 2,
			},
			595: { slidesPerView: 2, slidesPerColumn: 1 },
			769: { spaceBetween: 20, slidesPerView: 2, slidePerColumn: 1 },
			899: { slidesPerView: 3, spaceBetween: 20 },
		};
	}

	return {
		0: { slidesPerView: 2, spaceBetween: 8 },
		650: { slidesPerView: 3 },
		769: { spaceBetween: 20 },
		1025: { slidesPerView: 4, spaceBetween: 40 },
	};
});

async function fetch() {
	isLoading.value = true;

	const response = await getRecommendation(props.type);
	slider.value = response.data.result;

	isLoading.value = false;
}

function track(slide: ProductObjectViewModel | number) {
	if (typeof slide == "number") {
		return;
	}

	logClick(slide.id);
}

onMounted(() => {
	fetch();
});

return (_ctx: any,_cache: any) => {
  return (slider.value.show)
    ? (_openBlock(), _createBlock(ContentSlider, {
        key: 0,
        "content-id": slider.value.id,
        "slide-spacing": 8,
        "slide-overflow": false,
        "slide-breakpoints": breakpoints.value,
        "slide-shadow": true,
        inline: _ctx.inline,
        loading: isLoading.value
      }, {
        heading: _withCtx(() => [
          _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.heading), 1)
        ]),
        slides: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slider.value.slides, (slide) => {
            return (_openBlock(), _createBlock(_unref(SwiperSlide), null, {
              default: _withCtx(() => [
                (_ctx.inline)
                  ? (_openBlock(), _createBlock(InlineProduct, {
                      key: 0,
                      loading: isLoading.value,
                      product: slide,
                      onClick: ($event: any) => (track(slide))
                    }, null, 8, ["loading", "product", "onClick"]))
                  : (_openBlock(), _createBlock(CatalogProduct, {
                      key: 1,
                      loading: isLoading.value,
                      product: slide,
                      onClick: ($event: any) => (track(slide))
                    }, null, 8, ["loading", "product", "onClick"]))
              ]),
              _: 2
            }, 1024))
          }), 256))
        ]),
        _: 1
      }, 8, ["content-id", "slide-breakpoints", "inline", "loading"]))
    : _createCommentVNode("", true)
}
}

})